import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 * Motor Article Image (News)
 */
export default class ArticleImageEntity extends Entity {
  static IMAGE_CROP_PARAM = '432x243cut'

  /**
   * @constructor
   * @param {String} url
   * @param {String} cutCoordinates
   */

  getUrl = () =>
    this._cutCoordinates
      ? `${this._url}/${ArticleImageEntity.IMAGE_CROP_PARAM}/${this._cutCoordinates}/`
      : `${this._url}/${ArticleImageEntity.IMAGE_CROP_PARAM}/`
}
